

































































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import AppConsts from '@/lib/appconst';
    import ListMixin from '@/components/mixin/list-mixin';
    import { mixins } from 'vue-class-component';
import Ref from '@/store/entities/ref';
    class  PageLostFoundRequest extends PageRequest{
        keyword:string;
        type: string;
        status: string;
        fromDate: Date;
        toDate:Date; 
    }
    @Component({
       components:{}
    })
    export default class LostFound extends mixins(ListMixin, AbpBase){
        namespace = 'lostFound';
        pagerequest:PageLostFoundRequest=new PageLostFoundRequest();
        creationTime:Date[]=[];
        types : Ref[] = new Array<Ref>();
        statuses : Ref[] = new Array<Ref>();
        get store () {
          return this.$store.state.lostFound;
        }
       
        view(id:string)
        {
            this.$root.$router.push({name: 'view-lostfound/:id', params: {id: id}})
        }
         preGetPage () {
         
           if (this.creationTime.length>0) {
                this.pagerequest.fromDate=this.creationTime[0];
            }
            if (this.creationTime.length>1) {
                this.pagerequest.toDate=this.creationTime[1];
            }
        }
        get list(){
          var re = this.store.list;
          var startIndex = (this.currentPage - 1) * this.pageSize;
          var index = 0;
          re.forEach(function(item) {
            item.orderNo = startIndex + index + 1;
            index++;
          });
          return re;
        }
        columns= [
        {
            title:Util.L('Order'),
            key:'orderNo',
            width: 60
        },
        {
            title:Util.L('LocationCode'),
            key:'locationCode',
            width: 120
        },{
            title:Util.L('SKU'),
            key:'sku',
            width: 150
        }
        ,{
            title:Util.L('ProductName'),
            key:'productName',
            width: 200
        }
        ,{
            title:Util.L('Type'),
            key:'typeName',
            width: 120
        },{
            title:Util.L('Status'),
            key:'statusName',
            width: 120
        },{
            title:Util.L('Qty'),
            key:'qty',
            align: 'right',
             render:(h:any,params:any)=>{
                return h("span", Util.toViewNumberString(params.row.qty));
            },
            width: 100
        },{
            title:Util.L('ConfirmedQty'),
            key:'confirmedQty',
            align: 'right',
             render:(h:any,params:any)=>{
                return h("span", Util.toViewNumberString(params.row.confirmedQty));
            },
            width: 100
        }
        ,{
            title:Util.L('ConditionType'),
            key:'conditionTypeName',
            width: 100
        },{
            title:Util.L('CreationTime'),
            key:'creationTime',
            render:(h:any,params:any)=>{
                return h("span", Util.toViewDateString(params.row.creationTime));
            },
            width: "120"
        },{
                title: Util.L('Action'),
                width:100,
                fixed:'right',
                slot: 'action',
                align: 'center'
          }
        ]

        async created(){
            await this.$store.dispatch({
                type:'lostFound/getTypes',
                data:{ hasAllItem: true}
            })
            .then(() => {
              this.types = this.store.types;
              this.$set(this.pagerequest, 'type', this.types.length == 0 ? "" : this.types[0].code);
            });

            await this.$store.dispatch({
                type:'lostFound/getStatuses',
                data:{ hasAllItem: true}
            })
            .then(() => {
              this.statuses = this.store.statuses;
              this.$set(this.pagerequest, 'status', this.statuses.length == 0 ? "" : this.statuses[0].code);
            });
        }
    }
